/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoDirectoryDeleteMutation($phoneNumberoDirectoryId: ID!) {
  PhoneNumberoDirectoryDelete(phoneNumberoDirectoryId: $phoneNumberoDirectoryId) {
    id
    message
    status
  }
}
`
